import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DeliveryDiscountFilterEntity } from '../../domain/entities/DeliveryDiscountFilterEntity'

export class DeliveryDiscountFilterModel extends DeliveryDiscountFilterEntity {
  branchId?: number
  constructor(dataDto: DeliveryDiscountFilterEntity) {
    super()
    mapEntityProperties<DeliveryDiscountFilterModel>(this, dataDto, {
      exclude: ['branch'],
      map: {
        branchId: dataDto.branch?.id
      }
    })
  }
}
